import { OptionItems } from 'app/models';
import clsx from 'clsx';
import { FieldHookConfig, useField } from 'formik';
import _ from 'lodash';
import React from 'react';
import CreatableSelect from 'react-select/creatable';
import { Label } from 'reactstrap';

interface OtherProps {
  label: string;
  horizontal?: boolean;
  placeholder?: string;
  options: OptionItems[];
  onChange?: (str: any) => void;
  isClearable?: boolean;
  disabled?: boolean;
  isMulti?: boolean;
  formatCreateLabel?: (str) => React.ReactNode;
  isInModal?: boolean;
}

const CreatableSelectField = (props: OtherProps & FieldHookConfig<any>) => {
  const [field, meta, helpers] = useField(props);
  const {
    label,
    placeholder,
    options,
    onChange,
    isClearable,
    disabled,
    isMulti,
    formatCreateLabel,
    isInModal = false,
  } = props;
  const rendervalue = () => {
    const index = _.findIndex(options, option => option.value === field.value);
    if (index > -1) {
      return options[index];
    } else if (field.value !== '') {
      return { value: field.value, label: field.value };
    } else {
      return '';
    }
  };
  return (
    <div
      className={clsx(
        'mb-2',
        'form-group',
        meta.touched && meta.error && 'text-danger',
      )}
      style={{ height: 85 }}
    >
      {label ? <Label>{props.label}</Label> : null}
      <CreatableSelect
        isMulti={isMulti}
        defaultValue={isMulti ? field.value : rendervalue()}
        placeholder={placeholder}
        options={options}
        className={`${isMulti ? 'basic-multi-select' : 'basic-single'}`}
        classNamePrefix={`${isMulti ? '' : 'select2-selection'}`}
        formatCreateLabel={formatCreateLabel}
        {...field}
        onChange={e => {
          const value = isMulti ? e : e.value;
          if (e) {
            helpers.setValue(value);
          } else {
            helpers.setValue('');
          }
          if (onChange) {
            onChange(value);
          }
        }}
        value={isMulti ? field.value : rendervalue()}
        isClearable={isClearable}
        isDisabled={disabled}
        createOptionPosition="first"
        menuPortalTarget={!isInModal ? document.body : undefined}
        styles={{
          menuPortal: base => ({
            ...base,
            zIndex: 9999,
          }),
        }}
      />
      {meta.touched && meta.error ? <div>{meta.error}</div> : null}
    </div>
  );
};

export default CreatableSelectField;
